// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__y8-ZB","label":"Completed_label__3U1tq"};